import { COST_CENTER_JOBS } from "../types";

const CostCenterJobs = (state = [], action) => {
    if (action.type === COST_CENTER_JOBS) {
        state = action.payload;
    };
    return state;
};

export default CostCenterJobs;